export default __webpack_public_path__ + "static/media/Clouds.fd8c0fe3.svg";